import './../scss/angular2-calendar.scss';
export * from './index';


// WEBPACK FOOTER //
// ./~/tslint-loader?emitErrors=true&failOnHint=true!./src/index.umd.ts